import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ErrorFillImg from '../../assets/images/certificates/error_fill.png';

export default function ValidationError({ text }) {
    return (
        <span>
            <Stack
                direction={'row'}
                alignItems={'center'}
                justifyContent={'center'}
                style={{ backgroundColor: '#FFE9E9', borderRadius: 16 }}
                spacing={1}
                p={2}
            >
                <img height={'24'} width={'24'} src={ErrorFillImg} alt="error" />
                <Typography variant="caption" sx={{ lineHeight: '18px' }} color={'#D03232'} fontWeight={500}>
                    {text}
                </Typography>
            </Stack>
        </span>
    );
}
